import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { colspan: "14" }
const _hoisted_3 = { class: "table-header" }
const _hoisted_4 = { nowrap: "" }
const _hoisted_5 = { nowrap: "" }
const _hoisted_6 = { nowrap: "" }
const _hoisted_7 = { nowrap: "" }
const _hoisted_8 = { nowrap: "" }
const _hoisted_9 = { nowrap: "" }
const _hoisted_10 = { nowrap: "" }
const _hoisted_11 = { nowrap: "" }
const _hoisted_12 = { nowrap: "" }
const _hoisted_13 = { nowrap: "" }
const _hoisted_14 = { nowrap: "" }
const _hoisted_15 = { nowrap: "" }
const _hoisted_16 = { nowrap: "" }
const _hoisted_17 = { nowrap: "" }

import i18n from '@/lang/i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderRow',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", _hoisted_1, [
      _createElementVNode("td", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.totalTime')), 1)
    ]),
    _createElementVNode("tr", _hoisted_3, [
      _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.restraint')), 1),
      _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.workTime')), 1),
      _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.mileage')), 1),
      _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.driving')), 1),
      _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.break')), 1),
      _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.loading')), 1),
      _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.unloading')), 1),
      _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.shipping')), 1),
      _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.wait')), 1),
      _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.others')), 1),
      _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.rest')), 1),
      _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.duplication')), 1),
      _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.overTime')), 1),
      _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.lateNightWorkingHours')), 1)
    ])
  ], 64))
}
}

})